import { render, staticRenderFns } from "./abroad-used-name.vue?vue&type=template&id=52bc67aa&scoped=true&"
import script from "./abroad-used-name.vue?vue&type=script&lang=js&"
export * from "./abroad-used-name.vue?vue&type=script&lang=js&"
import style0 from "./abroad-used-name.vue?vue&type=style&index=0&id=52bc67aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc67aa",
  null
  
)

export default component.exports